import { faChevronDown } from '@fortawesome/pro-regular-svg-icons'
import { faCheck } from '@fortawesome/pro-solid-svg-icons'
import { DeviceWidth, useIsDeviceWidth } from '@/utils/deviceWidthHelpers'
import { TypographyStyles } from '@/styles'
import { Accordion, Card, CardColors, Icon, List, Popup, Text } from '@/ui'
import { selectProductDescription } from '@/features/user/signup/selectors'

export const DetailsAccordion = ({
  productDescription,
  hideTitle,
  forOneTimePayment = false,
}: {
  productDescription: ReturnType<typeof selectProductDescription>
  hideTitle?: boolean
  forOneTimePayment?: boolean
}) => {
  const isMobile = useIsDeviceWidth(DeviceWidth.mobile)

  return (
    <Accordion
      type="single"
      collapsible
      variant="text"
      className={`w-full ${isMobile ? 'mb-8' : 'mb-4'}`}
    >
      <Accordion.Item value="details">
        <Accordion.Trigger className="[&>span]:hidden justify-start">
          <div className="flex items-center gap-1">
            <Text variant={TypographyStyles.LABEL_SM}>
              {forOneTimePayment ? 'See Details' : 'Plan Details'}
            </Text>
            <Icon
              icon={faChevronDown}
              className="text-[10px] transition-transform duration-200 [[data-state=open]_&]:rotate-180"
            />
          </div>
        </Accordion.Trigger>

        <Accordion.Content>
          <Card
            color={CardColors.LEVEL_1}
            className={`w-full ${isMobile ? 'px-3.5' : ''}`}
          >
            <div className="flex flex-col gap-8">
              {productDescription
                ?.filter(({ isVisible }) => isVisible)
                .map(({ title, details }) => (
                  <div key={title}>
                    {!hideTitle && (
                      <div className="flex items-center gap-2">
                        <Text
                          variant={
                            isMobile
                              ? TypographyStyles.H2
                              : TypographyStyles.DISPLAY_XS
                          }
                          className="font-normal mb-4"
                        >
                          {title}
                        </Text>
                      </div>
                    )}

                    <List className="px-0">
                      {details.map((item) => (
                        <List.Item
                          key={item.text}
                          className="mb-4 flex items-center text-left"
                        >
                          <Icon
                            icon={faCheck}
                            color="text-green-50"
                            className="mr-1 inline-block"
                          />

                          {item.tooltip ? (
                            // Use Text underlined inside Popup so the dotted
                            // line follows the text (with descender skipping)
                            // — same hover affordance pattern used by
                            // about-your-practice form labels.
                            <Popup
                              content={item.tooltip}
                              trigger={
                                <Text
                                  variant={TypographyStyles.LABEL_SM}
                                  underlined
                                >
                                  {item.text}
                                </Text>
                              }
                            />
                          ) : (
                            <Text variant={TypographyStyles.LABEL_SM}>
                              {item.text}
                            </Text>
                          )}
                        </List.Item>
                      ))}
                    </List>
                  </div>
                ))}
            </div>
          </Card>
        </Accordion.Content>
      </Accordion.Item>
    </Accordion>
  )
}
